var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDriveLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 349 349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#4285f4;}.cls-4{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8);}.cls-5{fill:#0f9d58;}.cls-6{fill:#ffcd40;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 349,
    height: 349
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8",
    x1: 172.16,
    y1: 180.55,
    x2: 178.19,
    y2: 176.76,
    gradientTransform: "matrix(77.89, 0, 0, -67.2, -12749.58, 12673.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0.02
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u753B\u677F 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.2,208.81V276H253.25l37.87-67.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.14,208.81l39,67.2H91.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.44,69.24,53.34,208.81,91.2,276l91.36-157.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211,69.24H133.44l80.88,139.57h76.8Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDriveLogo);
export default "data:image/svg+xml;base64,PHN2ZyBpZD0i5Zu+5bGCXzEiIGRhdGEtbmFtZT0i5Zu+5bGCIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAzNDkgMzQ5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTt9LmNscy0ye2NsaXAtcGF0aDp1cmwoI2NsaXAtcGF0aCk7fS5jbHMtM3tmaWxsOiM0Mjg1ZjQ7fS5jbHMtNHtmaWxsOnVybCgj5pyq5ZG95ZCN55qE5riQ5Y+YKTt9LmNscy01e2ZpbGw6IzBmOWQ1ODt9LmNscy02e2ZpbGw6I2ZmY2Q0MDt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iMzQ5IiBoZWlnaHQ9IjM0OSIvPjwvY2xpcFBhdGg+PGxpbmVhckdyYWRpZW50IGlkPSLmnKrlkb3lkI3nmoTmuJDlj5giIHgxPSIxNzIuMTYiIHkxPSIxODAuNTUiIHgyPSIxNzguMTkiIHkyPSIxNzYuNzYiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoNzcuODksIDAsIDAsIC02Ny4yLCAtMTI3NDkuNTgsIDEyNjczLjQ1KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzFhMjM3ZSIgc3RvcC1vcGFjaXR5PSIwLjIiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxYTIzN2UiIHN0b3Atb3BhY2l0eT0iMC4wMiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjx0aXRsZT7nlLvmnb8gMTwvdGl0bGU+PGcgY2xhc3M9ImNscy0yIj48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik05MS4yLDIwOC44MVYyNzZIMjUzLjI1bDM3Ljg3LTY3LjJaIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNMTMwLjE0LDIwOC44MWwzOSw2Ny4ySDkxLjJaIi8+PHBhdGggY2xhc3M9ImNscy01IiBkPSJNMTMzLjQ0LDY5LjI0LDUzLjM0LDIwOC44MSw5MS4yLDI3Nmw5MS4zNi0xNTcuNjVaIi8+PHBhdGggY2xhc3M9ImNscy02IiBkPSJNMjExLDY5LjI0SDEzMy40NGw4MC44OCwxMzkuNTdoNzYuOFoiLz48L2c+PC9zdmc+";
export { ForwardRef as ReactComponent };